import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Guard from './guard'
import Private from './private'
import Public from './public'
import Faq from '../pages/faq/faq'
import Home from '../pages/home/home'
import Test from '../pages/test/test'
import Terms from '../pages/terms/terms'
import Policy from '../pages/policy/policy'
import AccountDeletion from '../pages/accountDeletion/accountDeletion'
import AboutUs from '../pages/aboutUs/aboutUs'
import NotFound from '../pages/notFound/notFound'
import OurStory from '../pages/ourStory/ourStory'
import WhatWeDo from '../pages/whatWeDo/whatWeDo'
import ContactUs from '../pages/contactUs/contactUs'
import Unsubscribe from '../pages/unsubscribe/unsubscribe'
import PricingPlans from '../pages/pricingPlans/pricingPlans'
import Verification from '../pages/verification/verification'
import ApiDocs from '../pages/apiDocs/apiDocs'
import Press from '../pages/press/press'
import PressRelease from '../pages/press/pressRelease'
import Layout from '../components/layout/layout'
import useApi, { CONTROLLER } from '../hooks/useApi'

const showApiDocs =
  process.env.REACT_APP_SHOW_API_ADDON_PLAN === '1' || process.env.NODE_ENV !== 'production';

const Routes = () => {
  const { execute } = useApi(CONTROLLER.AUTH);

  React.useEffect(() => {
    execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <Layout>
      <Switch>
        <Route
          path="/"
          exact
          component={Home}
        />
        <Route
          path="/contact-us"
          component={ContactUs}
        />
        <Route
          path="/about-us"
          component={AboutUs}
        />
        <Route
          path="/our-story"
          component={OurStory}
        />
        <Route
          path="/what-we-do"
          component={WhatWeDo}
        />
        <Route
          path="/pricing-plans"
          component={PricingPlans}
        />
        <Route
          path="/press/deeptrading-major-product-release-2026-03-03"
          component={PressRelease}
        />
        <Route
          path="/press"
          exact
          component={Press}
        />
        {showApiDocs && (
          <Route
            path="/rest-api"
            component={ApiDocs}
          />
        )}
        <Route
          path="/policy"
          component={Policy}
        />
        <Route
          path="/account-deletion"
          component={AccountDeletion}
        />
        <Route
          path="/terms"
          component={Terms}
        />
        <Route
          path="/faq"
          component={Faq}
        />

        <Route
          path="/verification"
          component={Verification}
        />
        <Route
          path="/unsubscribe"
          component={Unsubscribe}
        />
        <Route
          path="/test"
          component={Test}
        />

        <Guard
          path="/auth"
          ifLoggedIn={false}
          showComponent={Public}
          elseRedirectTo="/cabinet/stocks"
        />

        <Guard
          path="/cabinet"
          ifLoggedIn={true}
          showComponent={Private}
          elseRedirectTo="/auth/login"
        />
        
        <Route
          component={NotFound}
        />
      </Switch>
    </Layout>
  );
};

export default Routes;
